<template>
  <v-container fluid class="down-top-padding">
    <!-- <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb> -->
              <v-card v-if="dialog" max-width="500px">
                

                <v-card-text>
                  <v-container>
                    <h2 v-if='action == "Edit"'> Edit User</h2>
                    <h2 v-if='action == "Create"'> Create User</h2>
                    <v-row>
                      <v-col cols="6" >
                        <v-text-field v-model="editedItem['First Name']" label="First Name"></v-text-field>
                      </v-col>
                      <v-col cols="6" >
                        <v-text-field v-model="editedItem['Surname']" label="Surname"></v-text-field>
                      </v-col>
                      <v-col cols="6" >
                        <v-text-field v-model="editedItem['Organisation']" label="Organisation"></v-text-field>
                      </v-col>
                        <v-col cols="6" >
                        <v-select
                        :items="['Instructor','Admin','LGA Officer']"
                        item-text="name"
                        v-model='editedItem.Role'
                        :label="(editedItem.Role) ? editedItem.Role : 'Role' "
                        outlined
                        dense
                      ></v-select>
                      </v-col>

                      <v-col cols="6" >
                        <v-select
                        :items="['IOS','Andriod']"
                        item-text="name"
                        v-model='editedItem.Device'
                        :label="(editedItem.Device) ? editedItem.Device : 'Device' "
                        outlined
                        dense
                      ></v-select>
                      </v-col>

                      <v-col cols="12" >
                        <v-select
                        :items="lgasAll"
                        item-text="name"
                        v-model='editedItem.LGA'
                        :label="(editedItem.LGA) ? editedItem.LGA : 'LGA' "
                        outlined
                        dense
                      ></v-select>
                      </v-col>

                       <v-col cols="12" >
                        <v-text-field v-model="editedItem['email']" :disabled='action === "Edit"' label="Email"></v-text-field>
                      </v-col>
                      <v-col cols="12" v-if='action == "Create"'>
                        <v-text-field v-model="editedItem['password']" label="Password"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                  <p class="red--text"
                  v-if='validate'
                  > Please Fill All Fields With Proper Values </p>
                  <p class='red--text' v-if='errorMessage'>{{errorMessage}}</p>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" v-if='action == "Edit"'
                  :disabled='validate'
                    text @click="save">Save</v-btn>
                  <v-btn color="blue darken-1" text v-if='action == "Create"'
                    :disabled='validate'
                   @click="saveuser">Save</v-btn>
                 
                </v-card-actions>
                 
              </v-card>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please Wait....
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row v-if='!dialog'>
      <v-col cols="12" sm="12">
        <BaseCard heading="Users List">
        
          <div class="mt-4">
      <v-card-title>
      
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        style='margin-right:30px;'
        single-line
        hide-details
        
      ></v-text-field>
          <v-btn color="primary" style='float:right;' @click='adduser'>Add New User</v-btn>

    </v-card-title>
      
      <v-data-table :headers="headers" :search='search' :items="usersSet" sort-by="Date" :sort-desc='true' class="border">
        <template v-slot:item.Date="{ item }">
    <span>{{ new Date(item.Date).toLocaleDateString() }}</span>
  </template>
  <template v-slot:item.Logged="{ item }">
    <span v-if='item.Logged'> <b class='green-text'>Logged</b> </span>
    <span v-else> Not Logged </span>
  </template>
        <template v-slot:top>
          <!-- <v-toolbar flat color="white">
            <div style='position:absolute;right:10px;' v-if='$root.selectedLga == null'>
            <v-select :items="items" label="Filter" outlined  v-model='slFilter' class='mt-5' style='max-width:220px;'> </v-select>
            </div>
            <v-spacer></v-spacer>
            
          </v-toolbar> -->
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
      <div>
      </div>
    </div>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import {mapState} from 'vuex';
import firebase from "@/firebase";

export default {
  name: "Users",
    // computed:{ ...mapState(['users'])},
    computed:{
      usersSet() {
          return this.users
      },
      validate() {
        if(this.editedItem['First Name'].length < 3
        || this.editedItem["Surname"].length < 3
        || this.editedItem["Role"].length < 2
        || this.editedItem["LGA"].length < 3
        || this.editedItem["email"].length < 3
        || this.editedItem["Organisation"].length < 3
        || this.editedItem["Device"].length < 1
        )
        {
          return true
        }else{
          return false
        }
      }
    },
  data: () => ({
    errorMessage:null,
    lgasAll:[],
    selectedLga:false,
    action:"Edit",
    loading:false,
      editedItem:{
        "LGA":'',
        "First Name":'',
        "Surname":'',
        "Role":'',
        "email":'',
        "Description":'',
      },
      users:[],
    page: {
      title: "Users"
    },
    sortBy: '',
    sortDesc: false,
    slFilter:"",
    items: ['Clear'],
    search:'',
    dialog: false,
    editedIndex:0,
    headers: [
      { text: "Name", align: "start", sortable: false, value: "First Name"},
      { text: "Surname", value: "Surname" },
    //   { text: "Email", value: "email" },
    //   { text: "Organisation", value: "Organisation" },
      { text: "LGA", value: "LGA" },
      { text: "Role", value: "Role" },
      { text: "Device", value: "Device" },
      { text: "Actions", value: "actions", sortable: false }
    ],
  }),
  methods:{
      adduser() {
        this.action = "Create"
        this.editedItem['First Name'] = ''
        this.editedItem['Surname'] = ''
        this.editedItem['email'] = ''
        this.editedItem['password'] = ''
        this.editedItem['LGA'] = '' 
        this.editedItem['Device'] = '' 
        this.dialog = true;
      },
      async saveuser() {
        console.log('saveuser is running')
        this.loading = true;
        this.errorMessage = null
          await firebase.auth()
          .createUserWithEmailAndPassword(this.editedItem['email'], this.editedItem['password'])
          .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                console.log(user)
                  let users = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Users");
                   users.child(user.uid).set({
                  "UID":user.uid,
                  "LGA":this.editedItem['LGA'],
                  'First Name':this.editedItem['First Name'],
                  'Surname':this.editedItem['Surname'],
                  'email':this.editedItem['email'],
                  'Device':this.editedItem['Device'],
                  'Role':this.editedItem['Role'],
                  "Organisation":this.editedItem['Organisation'],
                  })
                  this.editedItem = {
                  "Role":'',"LGA":'','First Name':'','Surname':'','email':'','Device':'',"Organisation":'',"password":''
                }
                this.dialog = false
                this.loading = false
                // ...
            })
            .catch((error) => {
                this.errorMessage = error.message
                this.loading = false;
            });
      

      },
      close() {
          this.dialog = false;
      setTimeout(() => {
         this.editedItem = {
                  "Role":'',"LGA":'','First Name':'','Surname':'','email':'','Device':'',"Organisation":'',"password":''
                }
        this.editedIndex = -1;
      }, 300);
      },
      async save() {
        console.log('save is running')
        console.log(this.editedItem)
         this.loading = true;
        let users = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Users/"+this.editedItem.UID);
        await users.set({
        "UID":this.editedItem['UID'],
        "LGA":this.editedItem['LGA'],
        'First Name':this.editedItem['First Name'],
        'Surname':this.editedItem['Surname'],
        'email':this.editedItem['email'],
        'Device':this.editedItem['Device'],
        'Role':this.editedItem['Role'],
        "Organisation":this.editedItem['Organisation'],
        })
        this.editedItem = {
       "UID":'',
        "LGA":'',
        'First Name':'',
        'Surname':'',
        'email':'',
        'Device':'',
        'Role':'',
        "Organisation":'',
      }
      this.dialog = false
      this.loading = false
      },
      editItem( index ) {
        this.action = "Edit"
        this.editedIndex = this.users.indexOf(index);
        let item =  this.users[this.editedIndex];
       this.editedItem = {
         "UID":item['UID'],
        "LGA":item['LGA'],
        'First Name':item['First Name'],
        'Surname':item['Surname'],
        'email':item['email'],
        'Device':item['Device'],
        'Role':item['Role'],
        "Organisation":item['Organisation'],
       }
        this.dialog = true;

      },
      async deleteItem(item) {
        console.log(item)
      const index = this.users.indexOf(item);
      let dec = confirm("Are you sure you want to delete this item?");
       if(dec){
          this.users.splice(index, 1);
        let users = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Users/"+item.UID);
        await users.remove()
         firebase
         .auth()
        .deleteUser(item.UID)
        .then(() => {
          console.log('Successfully deleted user');
        })
        .catch((error) => {
          console.log('Error deleting user:', error);
        });
       }
        
    },
    lgaData(data) {
      data = data.val();
      this.lgasAll = []
      for(const prop in data) this.lgasAll.push(prop)
    },
      usersData(data) {
          data = data.val()
          this.users = [];
          for(const prop in data)
          {
            this.users.push({
              'UID': prop,
              "First Name": data[prop]['First Name'],
              "Surname": data[prop]['Surname'],
              "email": data[prop]['email'],
              "LGA": data[prop]['LGA'],
              "Role": data[prop]['Role'],
              "Device": (data[prop]['Device'] == undefined) ? '' : data[prop]['Device'],
              "Organisation": data[prop]['Organisation'],
            })
          }
      
      },
      fail(error) {
          console.log(error)
      }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },  
  async mounted() {
      let users = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Users");
      await users.on("value",this.usersData,this.fail);
      let lgas = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/LGAs");
      await lgas.on("value",this.lgaData,this.fail);
      setTimeout(() => {
      this.$root.loading = false
      }, 2000);
  }
};
</script>
